import React, { PropsWithChildren } from 'react'
import { CardSize } from './common/CardFrame'
import { Absolute } from '../bases/Absolute'
import { EnergyGauge } from '../am/EnergyGauge'
import Image from 'next/image'

const amProps = {
  S: { height: 148, width: 148 },
  M: { height: 180, width: 180 },
  L: { height: 256, width: 256 },
}

const energyGaugeProps = {
  S: { height: 60, style: { left: 34, bottom: 24 } },
  M: { height: 70, style: { left: 42, bottom: 30 } },
  L: { height: 100, style: { left: 62, bottom: 45 } },
}

export const EnergyArcadeMachine: React.FC<
  PropsWithChildren<{
    imageUrl: string
    energy?: number
    maxEnergy?: number
    extractedEnergy?: number
    cardSize: CardSize
    feverSparkRemain?: number | null
  }>
> = ({ children, imageUrl, energy, maxEnergy, extractedEnergy, feverSparkRemain, cardSize }) => {
  const am = amProps[cardSize]
  const gauge = energyGaugeProps[cardSize]
  return (
    <div
      className="relative aspect-square bg-black bg-cover bg-center"
      style={{ height: am.height, width: am.width }}
    >
      {imageUrl && (
        <Image
          src={imageUrl}
          alt="AM"
          objectFit="contain"
          height={am.height}
          width={am.width}
          className={`${feverSparkRemain === 0 ? 'grayscale' : ''}`}
        />
      )}
      {maxEnergy !== undefined && energy !== undefined && extractedEnergy !== undefined && (
        <Absolute style={gauge.style}>
          <EnergyGauge
            maxEnergy={maxEnergy}
            energy={energy}
            extractedEnergy={extractedEnergy}
            height={gauge.height}
            feverSparkRemain={feverSparkRemain}
          />
        </Absolute>
      )}
      {children}
    </div>
  )
}
